import React from 'react';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import styles from './unavailablePreview.module.scss';

/**
 * 不提供預覽的素材在預覽位置顯示的灰色眼睛，不能點、沒有 tooltip。
 */
export const UnavailablePreview: React.FC = () => (
  <span className={styles.unavailablePreview} data-testid='unavailable-preview'>
    <IconWithTooltip disabled icon={faEye} />
  </span>
);
